import store from '../store';

export const DATA_FETCHED_ERROR = 'DATA_FETCHED_ERROR';
export const DATA_FETCH_REQUEST = 'DATA_FETCHED_ERROR';
export const DATA_END_FETCH_REQUEST = 'DATA_FETCHED_ERROR';

export const DATA_SEARCH = 'search';

export const DATA_CONFIG = 'config';

export const CONFIG_BASE_URL = './config/';

const CONFIG_FILE = `${CONFIG_BASE_URL}netgem.json`;

const fetchRequest = (id) => ({
  type: DATA_FETCH_REQUEST,
  id
});

const endFetchRequest = (id) => ({
  type: DATA_END_FETCH_REQUEST,
  id
});

const fetchedError = (err) => ({
  type: DATA_FETCHED_ERROR,
  err
});

const responseReceived = (id, data) => ({
  type: id,
  data
});

export const setSearchTerm = (data) => ({
  type: DATA_SEARCH,
  data
})

export const loadConfiguration = () => doRequestJson(DATA_CONFIG, CONFIG_FILE)

const doRequestJson = (id, url, options) => {
  const opts = options || {}
  store.dispatch(fetchRequest(id));
  return (dispatch, getState) => {
    console.log('Fetch', url, opts)
    fetch(url, opts)
      .then((d) => d.json())
      .then((d) => dispatch(responseReceived(id, d)))
      .catch((e) => dispatch(fetchedError(e)))
      .finally(() => dispatch(endFetchRequest(id)));
  };
}